var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.colour)?_c('span',{staticClass:"label label-default",style:(`background-color: #${_vm.colour};`)},[_vm._v("\n           \n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }